import type {SlotGameStore} from "@gamzix/slot_core";

import {GameDataStore} from "../../../src/GameDataStore";

class BackgroundComponent extends Game.src.component.BaseComponent {

    setBonusGameBG() {
        
        game.tree.findByName('background_bonus_container').options.visible = true;
        game.tree.findByName('background_main_container').options.visible = false;
        game.tree.findByName('background_free_spins_container').options.visible = false;
        
        //@ts-ignore
        this.view.forceViewUpdate();
    }
    
    setMainGameBG() {
        if(this.gameData.freeSpinsGame.isPlaying()) return this.setFreeSpinsGameBG()

        game.tree.findByName('background_bonus_container').options.visible = false;
        game.tree.findByName('background_free_spins_container').options.visible = false;
        game.tree.findByName('background_main_container').options.visible = true;

        //@ts-ignore
        this.view.forceViewUpdate();
    }

    setFreeSpinsGameBG() {
        game.tree.findByName('background_bonus_container').options.visible = false;
        game.tree.findByName('background_main_container').options.visible = false;
        game.tree.findByName('background_free_spins_container').options.visible = true;

        //@ts-ignore
        this.view.forceViewUpdate();
    }
    
    getFSMHandlers():any {
        return {
            START: {
                checkRestoreBonusGame: {
                    on: () => {
                        this.setBonusGameBG();
                    }
                },
                checkRestoreFreeSpinsGame: {
                    on: () => {
                        if(this.store.gameData.bonusGame.isStarted()) {
                            return
                        }

                        this.setFreeSpinsGameBG();
                    }
                }
            }
        }
    }

    get gameData(): GameDataStore {
        return (<GameDataStore>this.store.gameData);
    }

    get store(): SlotGameStore {
        return <SlotGameStore>game.store;
    }
}

//@ts-ignore
Game.src.component.BackgroundComponent = BackgroundComponent;

